import { QC_OPTIONS } from '../Snapshot/constant';
import {
  CenterFilter,
  ExtractionQcStatusFilter,
  SnapshotComparisonFilters,
  TriStateFilter
} from './types';

export const DEFAULT_PAGE_SIZE = 20;

export const COMPARISON_COLUMN_WIDTH = 200;

export const PAGE_SIZE_OPTIONS = [10, 20, 40, 60];

/** sessionStorage key for list page filters and pagination. */
export const LIST_STATE_STORAGE_KEY = 'snapshotComparison.listState';

export const DEFAULT_FILTERS: SnapshotComparisonFilters = {
  applicationNumber: '',
  center: 'all',
  qcStatus: 'all',
  changeDetectionStatus: 'all',
  escalatedStatus: 'all',
  allVerdictFalse: 'all',
  extractionQcStatus: 'all',
  dataExtracted: 'all'
};

export const CENTER_FILTER_OPTIONS: { label: string; value: CenterFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'CDER', value: 'cder' },
  { label: 'CBER', value: 'cber' }
];

/** Label-comparison QC (`qc_status` boolean), not extraction curation. */
export const QC_STATUS_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'QCed', value: 'true' },
  { label: 'Not QCed', value: 'false' }
];

/** Same status values as Snapshot application / indication curation QC. */
export const EXTRACTION_QC_STATUS_FILTER_OPTIONS: {
  label: string;
  value: ExtractionQcStatusFilter;
}[] = [
  { label: 'All', value: 'all' },
  { label: 'Not QCed', value: 'not_qced' },
  ...(QC_OPTIONS as Array<{ label: string; value: ExtractionQcStatusFilter }>)
];

export const CHANGE_DETECTION_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];

export const ESCALATED_STATUS_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];

export const ALL_VERDICT_FALSE_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];

export const DATA_EXTRACTED_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];

export const DEFAULT_DETAIL_FILTERS = {
  verdict: 'all' as TriStateFilter,
  indChange: 'all',
  tier: 'all'
};

export const VERDICT_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'YES', value: 'true' },
  { label: 'NO', value: 'false' }
];
